<template>
  <v-form ref="form">
    <v-row class="py-3">
      <v-col md="6">
        <div class="tertiary--text text-body-2">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.card_field_activates_in'
            )
          }}
        </div>
        <v-select
          id="idEventosSeActivaEn"
          class=""
          v-model="movement_start.minimum_in_movement_time"
          item-value="time"
          required
          dense
          filled
          hide-details="auto"
          item-text="time"
          :items="allMinutesMin"
          color="tertiary"
          append-icon="mdi-alarm"
          @change="movementChange"
          :readonly="!editMode"
        ></v-select>
      </v-col>
      <v-col md="6">
        <div class="tertiary--text text-body-2">
          {{ 
            $t(
            'fleet_management.agents.agent_detail.partials.card_field_stop_max'
            )
          }}
        </div>
        <v-select
          id="idEventosParadaMaxima"
          class=""
          v-model="movement_start.minimum_stop_time"
          item-value="time"
          required
          dense
          filled
          hide-details="auto"
          item-text="time"
          :items="allMinutesStop"
          color="tertiary"
          append-icon="mdi-alarm"
          @change="movementChange"
          :readonly="!editMode"
        ></v-select>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'Movement',
  props: {
    movement: Object,
    editMode: Boolean
  },
  components: {},
  data() {
    return {
      edit: false,
      allMinutesMin: [],
      allMinutesStop: [],
      movement_start: {
        minimum_stop_time: null,
        minimum_in_movement_time: null
      },
      movement_old: {}
    }
  },
  methods: {
    movementChange() {
      const movementObj = {}
      movementObj['min_speed'] = 7
      movementObj['minimum_in_movement_time'] =
        this.movement_start.minimum_in_movement_time * 60
      movementObj['minimum_stop_time'] =
        this.movement_start.minimum_stop_time * 60
      this.$emit('movement', movementObj)
      this.validationsMovement()
    },
    validationsMovement() {
      if (
        this.movement_old.minimum_stop_time !==
          this.movement_start.minimum_stop_time ||
        this.movement_old.minimum_in_movement_time !==
          this.movement_start.minimum_in_movement_time
      ) {
        this.$emit('movementValidChild', true)
      } else {
        this.$emit('movementValidChild', false)
      }
    },
    _setMinutes(state, max = 61, min = 2, jump = 1) {
      for (let index = min; index < max; index += jump) {
        const time = {
          time: index,
          value: index * 60
        }
        this[state].push(time)
      }
    }
  },
  mounted() {
    if (this.movement) {
      const movementObj = new Object()

      this.movement_old = Object.assign({}, movementObj)
      movementObj['min_speed'] = 7
      movementObj['minimum_in_movement_time'] =
        this.movement.minimum_in_movement_time / 60
      movementObj['minimum_stop_time'] = this.movement.minimum_stop_time / 60
      this.movement_start = movementObj
    }
    this.$emit('movementValidChild', true)
    this._setMinutes('allMinutesMin', 61, 0)
    this._setMinutes('allMinutesStop', 61, 2)
  },
  watch: {
    editMode() {
      if (this.editMode == false) {
        this.movement_start.minimum_in_movement_time = this.movement.minimum_in_movement_time / 60
        this.movement_start.minimum_stop_time = this.movement.minimum_stop_time / 60
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
